import api from "@/libs/axios";
import * as ep from "../../endpoints";
import AdministrationService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";

const omitEmptyProps = (obj) => {
  const res = { ...obj };
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const element = obj[key];
      if (element === null || element === undefined || element === "")
        delete res[key];
    }
  }
  return res;
};
export default {
  namespaced: true,
  state: {
    employees: [],
    loading: false,
    rouls: [],
    loadingRouls: false,
    pagination: {},
    upDateLoading: false,
    creaateLoading: false,
  },
  getters: {
    rouls(state) {
      return state.rouls;
    },
    employees(state) {
      return state.employees;
    },
    loading(state) {
      return state.loading;
    },
    pagination(state) {
      return state.pagination;
    },
    loadingRouls(state) {
      return state.loadingRouls;
    },
    upDateLoading(state) {
      return state.upDateLoading;
    },
    creaateLoading(state) {
      return state.creaateLoading;
    },
  },

  mutations: {
    setEmployees(state, payload) {
      state.employees = payload;
    },
    setRouls(state, payload) {
      state.rouls = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
  },

  actions: {
    async getEmployeeById({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.get(ep.EMPLOYEE_BY_ID(payload.id, payload.type));
        if (hasError(res.status)) throw res.status;
        return Promise.resolve(res.data.data);
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },

    async updateEmployee({ commit }, payload) {
      commit("setLoading", true);
      try {
        const toSend = omitEmptyProps(payload.data);

        const res = await AdministrationService.updateEmployee({
          id: payload.id,
          type: payload.type,
          data: toSend,
        });

        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });

        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
    async addEmployee({ commit }, payload) {
      commit("setLoading", true);
      try {
        const toSend = omitEmptyProps(payload.data);
        const res = await AdministrationService.addEmployee({
          type: payload.type,
          data: toSend,
        });

        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء إضافة البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
    async deleteEmployee({ commit }, payload) {
      commit("setLoading", true);
      try {
        const res = await AdministrationService.deleteEmployee(payload);

        if (hasError(res.status)) {
          throw res.status;
        }
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل البيانات",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
